import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-bar.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-bar.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { fromEvent } from "rxjs";
import { SharedConstants } from "../../../constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let SearchBarComponent = class SearchBarComponent {
    changeDetectorRef;
    appController;
    searchBox;
    placeHolderText;
    searchOccurred = new EventEmitter();
    onClickSearchOccurred = new EventEmitter();
    debounceTime;
    showSearchButton;
    disabled;
    searchText;
    searchTextLabel = SharedConstants.SEARCH_PREFIX;
    textForSearch;
    fromEventSubscription;
    constructor(changeDetectorRef, appController) {
        this.changeDetectorRef = changeDetectorRef;
        this.appController = appController;
    }
    ngAfterViewInit() {
        this.listenForSearchChanges();
    }
    ngOnInit() {
        if (this.debounceTime < 0) {
            throw Error("Invalid debounce time");
        }
        if (this.debounceTime === undefined) {
            this.debounceTime = 0;
        }
    }
    searchTextChanged($event) {
        if (!this.showSearchButton) {
            this.searchOccurred.emit($event);
        }
        this.textForSearch = $event;
    }
    onSearchClick($event) {
        this.changeDetectorRef.detectChanges();
        this.onClickSearchOccurred.emit(this.searchBox.nativeElement.value);
    }
    listenForSearchChanges() {
        this.fromEventSubscription =
            fromEvent(this.searchBox.nativeElement, "keyup")
                .pipe(map((event) => {
                return event.target.value;
            }), debounceTime(this.debounceTime), distinctUntilChanged())
                .subscribe((text) => {
                this.searchTextChanged(text);
            });
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: AppControllerService }
    ];
    static propDecorators = {
        searchBox: [{ type: ViewChild, args: ["searchInput", { static: false },] }],
        placeHolderText: [{ type: Input }],
        searchOccurred: [{ type: Output }],
        onClickSearchOccurred: [{ type: Output }],
        debounceTime: [{ type: Input }],
        showSearchButton: [{ type: Input }],
        disabled: [{ type: Input }]
    };
};
SearchBarComponent = __decorate([
    Component({
        selector: "app-search-bar",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchBarComponent);
export { SearchBarComponent };
